let mo_sales_modal = document.getElementById("mo-sales-popup");
let mo_sales_popup_ab = false;

window.addEventListener('load', (event) => {
  mo_sales_modal = document.getElementById("mo-sales-popup");
  const mo_sales_modal_close = mo_sales_modal.getElementsByClassName("mo-close-btn")[0];
  //console.log("🚀 ~ file: mo-sales-popup.js:7 ~ window.addEventListener ~ mo_sales_modal_close:", mo_sales_modal_close)
  
  const mo_sales_modal_cancel = mo_sales_modal.getElementsByClassName("mo-cancel-btn")[0];
  //const mo_sales_popup_cta = document.getElementById("mo-sales-popup-cta")

  window.addEventListener('click', (e) => {
    if (e.target == mo_sales_modal) {
      mo_sales_modal.style.display = "none";
      document.body.style.overflow = "auto";
    }
  });
  
  mo_sales_modal_close.addEventListener('click', (event) => {
    mo_sales_modal.style.display = "none";
    document.body.style.overflow = "auto";
  });
  
  mo_sales_modal_cancel.addEventListener('click', (event) => {
    mo_sales_modal.style.display = "none";
    document.body.style.overflow = "auto";
  });

  /*
  mo_sales_popup_cta.addEventListener('click', (event) => {
    ga('send', 'event', 'Exit Modal CTA', 'Exit Modal Pop-Up', 'PLP');
  });
  */
  
});

function show_sales_modal() {

  
  if (mo_sales_popup_ab === false ) return;

  // do not display when sign up popup is shown
  const element = document.querySelector('#ps__widget_container iframe');
  if (!element || element.style.display == "none") {
    mo_sales_modal.style.display = "flex";
    document.body.style.overflow = "hidden";
    sessionStorage.setItem("salespopupshown", true);
  }
}


/*** mo show popup for fast mouse move to top for desktop */

const threshold = 50;

let prevX = null;
let prevY = null;
let exiting = false;

document.addEventListener('mousemove', event => {

  //console.log("====> mousemove")
  // Check if the screen is a desktop

  const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
  //const exitX = window.innerWidth - 50
  //const wWidth = window.innerWidth / 2
  const shown = sessionStorage.getItem("salespopupshown")

  // If not a desktop, return
  if (!isDesktop || shown) {
    return;
  }

  const x = event.clientX;
  const y = event.clientY;
/*
  if (exiting && y < 50) {
    show_sales_modal()
    exiting = false;
  }
*/
  //console.log("y: " + y + " x: " + x)


  if (prevX === null || prevY === null) {
    prevX = x;
    prevY = y;
    return;
  }

  //console.log("prevY: " + prevY + " prevX: " + prevX)


  const dx = x - prevX;
  const dy = y - prevY;
  const distance = Math.sqrt(dx * dx + dy * dy);

  //console.log("dx: " + dx  + " - dy: " + dy)
  //if ((prevX > x) || (prevY < y) ) return;


  if (dy < -threshold && distance > threshold ) {
    if (dy < 0 && y < 90){
      show_sales_modal()
    }
  }

  prevX = x;
  prevY = y;
});



/** mo show popup on 60s inactivity for mobile/tablet */

// Set the time limit for inactivity in milliseconds
const inactivityTimeLimit = 60000; // 60 seconds

// Initialize a variable to store the timestamp of the last user activity
let lastActivityTimestamp = Date.now();

// Listen for user activity events
document.addEventListener('touchstart', resetActivityTimer);
document.addEventListener('touchmove', resetActivityTimer);
document.addEventListener('touchend', resetActivityTimer);
document.addEventListener('click', resetActivityTimer);
document.addEventListener('mousemove', resetActivityTimer);

// Start a timer to check for inactivity
const inactivityTimer = setInterval(checkInactivity, 1000); // check every second

// Function to reset the activity timer
function resetActivityTimer() {
  lastActivityTimestamp = Date.now();
}

// Function to check for inactivity
function checkInactivity() {
  // Check if the screen is a mobile or tablet
  const isMobileOrTablet = window.matchMedia('(max-width: 1023px)').matches;
  const shown = sessionStorage.getItem("salespopupshown")

  // If not a mobile or tablet, return
  if (!isMobileOrTablet || shown) {
    return;
  }

  // Get the current timestamp
  const currentTimestamp = Date.now();

  // Calculate the time elapsed since the last user activity
  const elapsed = currentTimestamp - lastActivityTimestamp;

  // If the time elapsed is greater than the time limit, trigger an alert
  if (elapsed >= inactivityTimeLimit) {
    show_sales_modal();
  }
}





